<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="login-title" v-if="isOdysseySite">כניסת סוכנים</div>
        <div class="login-subtitle" v-if="isOdysseySite">הכניסה מאומתת מול אטלנטיס — אותם קוד סוכן, שם משתמש וסיסמה של מערכת ההזמנות.</div>
        <div class="w-full" v-if="isOdysseySite"> <!-- Agent login part -->
          <!-- Agent login has its own title/subtitle above; skip the logo avatar entirely
               so nothing empty pads the space between subtitle and the first input. -->
          <!-- <div class="login100-form-avatar mb-3" v-if="srcLogo && !isOdysseySite">
            <img :src="srcLogo" alt="logo">
          </div> -->

          <div class="wrap-input100 mb-3">
            <b-form-input type="text" class="input100" :state="!!odyAgentCode" placeholder="סוכנות" v-model="odyAgentCode"></b-form-input>
            <span class="symbol-input100">
              <i class="fa fa-id-card"></i>
            </span>
          </div>
          <div class="wrap-input100 mb-3">
            <b-form-input type="text" class="input100" :state="!!clerkName" placeholder="שם משתמש" v-model="clerkName"></b-form-input>
            <span class="symbol-input100">
              <i class="fa fa-user"></i>
            </span>
          </div>
          <div class="wrap-input100 mb-3">
            <b-form-input
              type="password"
              class="input100"
              :state="!!password"
              placeholder="סיסמא"
              v-model="password"
              @keypress.enter="() => requestAgentLogin()"
            ></b-form-input>
            <span class="symbol-input100">
              <i class="fa fa-lock"></i>
            </span>
          </div>

          <div class="container-login100-form-btn mt-3">
            <b-button class="login100-form-btn" @click="requestAgentLogin">
              {{$t("login.odyssey-login")}}
            </b-button>
          </div>
        </div>

        <div class="w-full" v-else-if="isLoginMarketer"> <!-- Marketer login part -->
          <div class="login100-form-avatar mb-5">
            <img :src="srcLogo" :alt="agencyName">
          </div>

          <span class="login100-form-title pt-20 pb-45 mb-3">
            {{ agencyName }}
          </span>

          <!-- for 1FA and pass login marketer -->
          <div class="mb-3" v-if="!is2FA && !preferSmsToPass">
            <div class="text-center w-full guide-caption">
              {{ $t("login.enter-marketer-password") }}
            </div>

            <div class="wrap-input100 mb-3">
              <b-form-input
                type="password"
                class="input100"
                :state="!!marketerPassword"
                placeholder="Password"
                v-model="marketerPassword"
                @keypress.enter="() => requestMarketerPassLogin()"
              ></b-form-input>
              <span class="symbol-input100">
                <i class="fa fa-lock"></i>
              </span>
            </div>

            <div class="container-login100-form-btn">
              <b-button class="login100-form-btn" @click="requestMarketerPassLogin">
                {{$t("login.agency-login")}}
              </b-button>
            </div>
          </div>

          <!-- Step 1: Request Sms login -->
          <div class="mb-3" v-else-if="!agencySid">
            <div class="w-full" v-if="is2FA">
              <div class="text-center w-full mb-4 guide-caption">
                {{ $t("login.enter-passcode") }}
              </div>

              <div class="wrap-input100 mb-3">
                <b-form-input
                  type="text"
                  class="input100"
                  :state="!!passCode"
                  placeholder="Passcode"
                  v-model="passCode"
                  @keypress.enter="() => requestMarketerSmsLogin()"
                ></b-form-input>
                <span class="symbol-input100">
                  <i class="fa fa-id-card"></i>
                </span>
              </div>
            </div>

            <div class="container-login100-form-btn">
              <b-button class="login100-form-btn" @click="requestMarketerSmsLogin">
                {{$t("login.agency-login")}}
              </b-button>
            </div>
          </div>

          <!-- Step 2: Request Verify Code -->
          <div class="mb-3" v-else>
            <div class="text-center w-full mb-4 guide-caption">
              {{ $t("login.enter-sms-code") }}
            </div>
            <div class="text-center w-full mb-3 sms-notify-caption" v-if="remainingTime > 0">
              {{ $t("login.sms-verify-message-with-time", { time: formattedRemainingTime }) }}
            </div>
            <div class="text-center w-full mb-3 flex flex-col" v-else>
              <p class="expired-message mb-2">{{ $t("login.sms-verify-expired-message") }}</p>
              <b-button class="resend-button" @click="requestMarketerSmsLogin">
                {{ $t("login.resend-passcode") }}
              </b-button>
            </div>
            <div class="wrap-input100 mb-3">
              <b-form-input
                type="text"
                class="input100"
                :state="!!verifyCode"
                placeholder="Verify Code"
                v-model="verifyCode"
                @keypress.enter="() => requestVerifyCode()"
              ></b-form-input>
              <span class="symbol-input100">
                <i class="fa fa-id-card"></i>
              </span>
            </div>

            <div class="container-login100-form-btn">
              <b-button class="login100-form-btn" @click="requestVerifyCode">
                {{$t("login.agency-verify-sms")}}
              </b-button>
            </div>
          </div>
        </div>

        <div class="w-full">
          <!-- Cancel Button -->
          <div class="container-login100-form-btn mt-3">
            <b-button class="login100-form-btn" @click="cancelLogin">
              {{$t("login.cancel")}}
            </b-button>
          </div>

          <!-- error message -->
          <div class="text-center w-full error-message" v-if="errorMessage">
            {{ $t("login.login-error-message") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BButton, BFormInput } from 'bootstrap-vue';

export default {
  name: 'agency-agent-login',
  components: {
    BButton, BFormInput,
  },
  data() {
    return {
      odyAgentCode: '',         // Odyssey Agent Code
      clerkName: '',            // Clerk Name
      password: '',             // agent Password
      marketerPassword: '',     // marketer Password
      passCode: '',             // Passcode (pax id)
      verifyCode: '',           // Verify Code
      remainingTime: 0,         // Time left for verify code
    };
  },
  mounted() {
    // Start countdown for remaining time
    this.startCountdown();
  },
  computed: {
    ...mapGetters({
      isAuthorized: 'IS_AGENCY_AUTHORIZED',
      whiteLabel: 'GET_WHITE_LABEL_DATA',
      marketerAgencyContent: 'GET_MARKETER_AGENCY_CONTENT',
      errorMessage: 'GET_AGENCY_ERROR_MESSAGE',
      agencySid: 'GET_AGENCY_SID',
      isOdysseySite: 'GET_ODYSSEY_AGENT_STATE',
      odysseyAgentContent: 'GET_ODYSSEY_AGENT_CONTENT',
      isLoginMarketer: 'GET_IS_LOGIN_MARKETER',
      is2FA: 'GET_IS_2FA',
      preferSmsToPass: 'GET_PREFER_SMS_PASS',
    }),
    srcLogo() {
      const { isOdysseySite, odysseyAgentContent, marketerAgencyContent,  whiteLabel } = this;
      if (isOdysseySite) {
        return odysseyAgentContent.logoUrls?.[0] || '';
      }

      return marketerAgencyContent?.logoUrls?.[0] || whiteLabel.logoUrls?.[0] || '';
    },
    agencyName() {
      const { marketerAgencyContent } = this;
      return (marketerAgencyContent === null) ? this.whiteLabel.name_Loc.content : marketerAgencyContent.name_Loc.content;
    },
    formattedRemainingTime() {
      const minutes = Math.floor(this.remainingTime / 60);
      const seconds = this.remainingTime % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    },
  },
  watch: {
    verifyCode() {
      this.$store.commit('SET_AGENCY_VERIFY_CODE', this.verifyCode);
    },
    agencySid() {
      this.verifyCode = '';
    },
  },
  methods: {
    async requestAgentLogin() {
      if (this.isOdysseySite && (this.clerkName && this.password && this.odyAgentCode)) {
        await this.$store.dispatch('REQUEST_AGENCY_LOGIN', { odyAgentCode: this.odyAgentCode, clerkName: this.clerkName, password: this.password });
      }
    },
    async requestMarketerPassLogin() {
      await this.$store.dispatch('REQUEST_MARKETER_PASS_LOGIN', { password: this.marketerPassword });
    },
    async requestMarketerSmsLogin() {
      this.remainingTime = await this.$store.dispatch('REQUEST_MARKETER_SMS_LOGIN', { passCode: this.passCode });
      if( this.remainingTime > 0) {
        this.startCountdown();
      }
    },
    async requestVerifyCode() {
      await this.$store.dispatch('REQUEST_AGENCY_BY_VERIFY_CODE');
    },
    async cancelLogin() {
      if (this.isAuthorized) {
        await this.$store.dispatch('REQUEST_AGENCY_LOGOUT');
      }

      if (this.isOdysseySite) {
        window.location.href = process.env.VUE_APP_MAIN_DOMAIN;
      } else {
        window.location = '/';
      }
    },
    startCountdown() {
      const interval = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
a {
  font-size: 14px;
  line-height: 1.7;
  color: #666666;
  margin: 0px;
  transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
}

a:focus {
  outline: none !important;
}

a:hover {
  text-decoration: none;
  color: #fff;
}

/*---------------------------------------------*/
h1,h2,h3,h4,h5,h6 {
  margin: 0px;
}

p {
  font-size: 14px;
  line-height: 1.7;
  color: #666666;
  margin: 0px;
}

ul, li {
  margin: 0px;
  list-style-type: none;
}

/*---------------------------------------------*/
input {
  outline: none;
  border: none;
}

textarea {
  outline: none;
  border: none;
}

textarea:focus, input:focus {
  border-color: transparent !important;
}

input:focus::-webkit-input-placeholder { color:transparent; }
input:focus:-moz-placeholder { color:transparent; }
input:focus::-moz-placeholder { color:transparent; }
input:focus:-ms-input-placeholder { color:transparent; }

textarea:focus::-webkit-input-placeholder { color:transparent; }
textarea:focus:-moz-placeholder { color:transparent; }
textarea:focus::-moz-placeholder { color:transparent; }
textarea:focus:-ms-input-placeholder { color:transparent; }

input::-webkit-input-placeholder { color: #999999; }
input:-moz-placeholder { color: #999999; }
input::-moz-placeholder { color: #999999; }
input:-ms-input-placeholder { color: #999999; }

textarea::-webkit-input-placeholder { color: #999999; }
textarea:-moz-placeholder { color: #999999; }
textarea::-moz-placeholder { color: #999999; }
textarea:-ms-input-placeholder { color: #999999; }

/*---------------------------------------------*/
button {
  outline: none !important;
  border: none;
  background: transparent;
}

button:hover {
  cursor: pointer;
}

iframe {
  border: none !important;
}

/*//////////////////////////////////////////////////////////////////
[ Utility ]*/
.txt1 {
  font-size: 16px;
  color: #cccccc;
  line-height: 1.4;
}
/* Recoloured for the light card background — dark shadows / neon colors were for the old dark overlay. */
.sms-notify-caption {
  color: #6b7d95;
  font-size: 0.95rem;
}
.guide-caption {
  color: #1a3a5c;
  font-size: 1rem;
  font-weight: 600;
}
.error-message {
  color: #a3271f;
  font-size: 0.9rem;
  margin-top: 8px;
  padding: 8px 12px;
  background: #fdecec;
  border: 1px solid #f0b8b8;
  border-radius: 8px;
}
.expired-message {
  color: #a3271f;
  font-size: 0.9rem;
  font-weight: 500;
}
.resend-button {
  background-color: #005bea;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.resend-button:hover {
  background-color: #003c8f;
}

.bo1 {
  border-bottom: 1px solid #999999;
}

.hov1:hover {
  border-color: #d33f8d;
}

/*//////////////////////////////////////////////////////////////////
[ login ]*/

.limiter {
  width: 100%;
  margin: 0 auto;
}

/* Ofir's redesign — no background image, plain canvas, centered white card. */
.container-login100 {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background: #eff3f8;
  position: relative;
  z-index: 1;
}

/* No gradient/overlay any more. */
.container-login100::before { display: none; }

.wrap-login100 {
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border: 1px solid #dfe4ea;
  border-radius: 24px;
  box-shadow: 0 10px 30px -12px rgba(78, 109, 151, 0.25);
  padding: 32px;
}

.login-title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 6px;
}
.login-subtitle {
  text-align: center;
  font-size: 12px;
  color: #6b7d95;
  /* Tight — Ofir asked for a small (~5px) gap between subtitle and first input. */
  margin-bottom: 6px;
  line-height: 1.5;
}

/*------------------------------------------------------------------
[  ]*/
.login100-form {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.login100-form-title {
  font-size: 24px;
  color: #fff;
  line-height: 1.2;
  text-align: center;

  width: 100%;
  display: block;
}

/*---------------------------------------------*/
.login100-form-avatar {
  max-width: 80%;
  overflow: hidden;
  margin: 0 auto;
}
.login100-form-avatar img {
  width: 100%;
  height: 100%;
}

/*---------------------------------------------*/
.wrap-input100 {
  position: relative;
  width: 100%;
  z-index: 1;
}

.input100 {
  font-size: 14px;
  line-height: 1.2;
  color: #1a3a5c;

  display: block;
  width: 100%;
  height: 42px;
  border-radius: 10px;
  /* RTL: icon sits at the RIGHT (visual end), so give text more room away from it. */
  padding: 0 46px 0 12px !important;
  border: 1px solid #d7dee7;
  background: #f7f9fb;
  background-position: left calc(0.375em + 0.5rem) center;
  text-align: right;
}
.input100:focus {
  border-color: #1f4c96;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(31, 76, 150, 0.15);
}

/*------------------------------------------------------------------
[ Focus ]*/
.focus-input100 {
  display: block;
  position: absolute;
  border-radius: 25px;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 0px 0px;
  color: rgba(0,91,234, 0.6);
}

.input100:focus + .focus-input100 {
  -webkit-animation: anim-shadow 0.5s ease-in-out forwards;
  animation: anim-shadow 0.5s ease-in-out forwards;
}

@-webkit-keyframes anim-shadow {
  to {
    box-shadow: 0px 0px 80px 30px;
    opacity: 0;
  }
}

@keyframes anim-shadow {
  to {
    box-shadow: 0px 0px 80px 30px;
    opacity: 0;
  }
}

/* Icon pinned to the visual right (RTL) with breathing room — the old rules
   spanned the whole width and butted straight up against the placeholder. */
.symbol-input100 {
  font-size: 15px;
  color: #6b7d95;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 14px;
  left: auto;
  width: auto;
  padding: 0;
  pointer-events: none;
  transition: color 0.2s;
}

.input100:focus + .focus-input100 + .symbol-input100 {
  color: #1f4c96;
  right: 14px;
}

/*------------------------------------------------------------------
[ Button ]*/
.container-login100-form-btn {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.login100-form-btn {
  font-size: 14px;
  line-height: 1.5;
  color: #ffffff;
  font-weight: 600;

  width: 100%;
  height: 44px;
  border-radius: 10px;
  background: #1f4c96;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  transition: background 0.2s;
  position: relative;
  z-index: 1;
}
.login100-form-btn::before { display: none; }
.login100-form-btn:hover {
  background: #163b78;
  color: #ffffff;
}

/*------------------------------------------------------------------
[ Button sign in with ]*/
.btn-face,
.btn-google {
  font-size: 16px;
  line-height: 1.2;

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc((100% - 10px) / 2);
  height: 40px;
  border-radius: 3px;
  border: 1px solid #e6e6e6;
  background-color: #fff;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.btn-face {
  color: #3b5998;
}

.btn-face i {
  font-size: 20px;
  margin-right: 10px;
  padding-bottom: 1px;
}

.btn-google {
  color: #555555;
}

.btn-google img {
  width: 19px;
  margin-right: 10px;
  padding-bottom: 1px;
}

.btn-face:hover,
.btn-google:hover {
  border-color: #d33f8d;
}

@media (max-width: 576px) {
  .wrap-login100 {
    padding-top: 80px;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
